import { Button, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";

export default function FileRow() {
	const { values, actions } = useContext(Context);
	const { translate } = useLocales();

	return (
		<Stack
			flexDirection={"row"}
			alignItems={"center"}
			justifyContent='space-between'
			sx={{ mt: 2 }}
		>
			<Typography variant='subtitle2' sx={{ mt: 1 }}>
				{values.file?.name}
			</Typography>
			<Button
				variant={"text"}
				size='small'
				color='error'
				onClick={() => actions.setValue("file", undefined)}
			>
				{translate("logo_selector.delete")}
			</Button>
		</Stack>
	);
}
